import React, { useState } from 'react';
import api from '../../../config/axios';
import Swal from 'sweetalert2';

import { FaRegSave, FaTimes, FaTrashAlt, FaPlus } from 'react-icons/fa';

const CategoriaModal = ({ categoriaLista, onClose, onCategoriaAtualizado }) => {
    const [categorias, setCategorias] = useState(categoriaLista);
    const [removedCategorias, setRemovedCategorias] = useState([]);

    const addCategoria = () => {
        setCategorias([...categorias, { nome: "" }]);
    };

    const removeCategoria = (index) => {
        const categoriaToRemove = categorias[index]; 
        if (categoriaToRemove) {
            setRemovedCategorias([...removedCategorias, categoriaToRemove]); 
            setCategorias(categorias.filter((_, i) => i !== index)); 
        }
    };   

    const handleCategoriaChange = (id, value) => {
        setCategorias((prev) =>
            prev.map((input) =>
                input.id === id ? { ...input, nome: value } : input
            )
        );
    };

    const handleSave = async () => {
        const data = {
            categorias: categorias,
            categoriasRemovidas: removedCategorias.map((item) => item.id)
        };
        
        Swal.fire({
            title: "Carregando...",
            allowOutsideClick: false,
            allowEscapeKey: false,
            showConfirmButton: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        try {
            await api.post(`/categorias`, data);

            onCategoriaAtualizado();
            onClose();
            Swal.fire("Sucesso", "Categorias salvas com sucesso!", "success");
        }
        catch (error) {
            Swal.close();
            Swal.fire('Erro', `${error.response.data.message}`, 'error');
        }
    };

    return (
        <div className="modal fade show" tabIndex="-1" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
            <div className="modal-dialog modal-md modal-dialog-scrollable modal-dialog-centered">
                <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                    <div className="modal-header">
                        <h4 className="fw-bold mt-2">Categorias</h4>
                        <button type="button" className="btn-close" onClick={onClose} aria-label="Close"></button>
                    </div>

                    <div className="modal-body">

                        <div className="d-flex mb-2 justify-content-between align-items-end">
                            <label className="fw-bold">Nome</label>
                            <button type="button" className="btn btn-outline-primary mt-2" onClick={addCategoria}>
                                <FaPlus /> Adicionar Categoria
                            </button>
                        </div>
                        <div className="row max-h-400 overflow-y-auto">
                            {categorias.map((input, index) => (
                                <div key={index} className="d-flex align-items-center mt-3">
                                    <input
                                        type="text"
                                        className="form-control me-2"
                                        value={input.nome}
                                        onChange={(e) => handleCategoriaChange(input.id, e.target.value)}
                                        placeholder="Digite o nome da categoria"
                                    />
                                    <button className="btn btn-danger" onClick={() => removeCategoria(index)}>
                                        <FaTrashAlt />
                                    </button>
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className="modal-footer mt-4">
                        <div className="row">
                            <div className="col-12 text-end">
                                <button className="btn btn-outline-danger" type="button" onClick={onClose}>
                                    <FaTimes /> Fechar
                                </button>
                                <button className="btn btn-custom-primary ms-3" type="submit" onClick={handleSave}>
                                    <FaRegSave /> Salvar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div >
    );
};

export default CategoriaModal;
